'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_LABELKEY = exports.DEFAULT_LABELKEY = 'label';


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/constants/defaultLabelKey.js
// module id = 630
// module chunks = 0